import { PaginatedResponse } from "shared/types";

export interface LockboxProperty {
  id: number;
  name: string;
  address?: {
    address1?: string;
    address2?: string;
    city?: string;
    state_or_province?: string;
    postal_code?: string;
  };
}

export interface LockboxUnit {
  id: number;
  title: string;
}

export interface LockboxCreatedBy {
  id: number;
  name: string;
  email: string;
}

export interface Lockbox {
  id: number;
  name: string;
  code: string | null; // vendor code 1 / admin code 1
  code_2: string | null;
  code_3: string | null;
  notes: string | null;
  purchase_date: string | null; // ISO "YYYY-MM-DD"
  last_battery_replacement_date: string | null; // ISO "YYYY-MM-DD"
  property: LockboxProperty | null;
  unit: LockboxUnit | null;
  created_at: string;
  updated_at: string; // read-only, server-managed
  created_by: LockboxCreatedBy | null;
}

export enum SortOrder {
  ASC = "asc",
  DESC = "desc"
}

export interface GetLockboxesParams {
  page?: number;
  per_page?: number;
  search?: string;
  sort_by?: string;
  sort_order?: SortOrder;
  property_id?: number;
  no_property?: boolean;
  allow_no_property?: boolean;
  unit_id?: number;
  available?: boolean;
}

export type GetLockboxesResponse = PaginatedResponse<Lockbox>;

export interface LockboxPayload {
  name: string;
  code?: string;
  property_id?: number | null;
  unit_id?: number | null;
  code_2?: string | null;
  code_3?: string | null;
  notes?: string | null;
  purchase_date?: string | null;
  last_battery_replacement_date?: string | null;
}
